module.exports = __webpack_public_path__ + "img/holiday.99699da1.png";